import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'or-profile-image',
    templateUrl: './profile-image.component.html',
    styleUrls: ['./profile-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProfileImageComponent implements OnInit, OnChanges {
  @Input() url: string;
  @Input() name: string;
  @Input() names = [];
  @Input() showRole = true;
  @Input() icon: string;
  @Input() showInitials: boolean = false;
  @Input() type = 'circle';
  @Input() size = 'medium';
  @Input() selected = false;
  @Input() showOnHover = false;
  @Input() showPlus = false;
  @Input() tooltipPlacement = "top";

  // Pre-computed values
  nameInitials: string = '';
  namesWithTooltips: any[] = [];
  namesTooltips: string = '';

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.preComputeValues();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Only recompute if relevant inputs changed
    if (changes['name'] || changes['names'] || changes['showRole']) {
      this.preComputeValues();
      this.cdr.markForCheck();
    }
  }

  private preComputeValues() {
    // Pre-compute name initials
    this.nameInitials = this.getInitials(this.name);

    // Pre-compute names with tooltips
    if (this.names && this.names.length > 0) {
      this.namesWithTooltips = this.names.map(item => ({
        ...item,
        _tooltip: this.getTooltip(item),
        _initials: this.getInitials(item?.name)
      }));

      // Pre-compute tooltips string for showPlus mode
      this.namesTooltips = this.getTooltips(this.names);
    }
  }

  getInitials(name) {
    if(name == null || name == undefined || name == '' || typeof name != 'string') return '';
    return name.split(' ').map(x => x.charAt(0)).join('').substr(0, 2).toUpperCase();
  }

  getTooltip(item) {
    var role = '';
    if (this.showRole) {
      role = '(' + (
          item?.type == 'secondPm' ? 'Secondary PM' :
          item?.type == 'oa' ? 'OA' :
          item?.type == 'accountOwner' ? 'Account Owner' :
          item?.type == 'pm' ? 'PM' :
          item?.type == 'programmer' ? 'Programmer' : // Added condition for 'programmer'
          'N/A'
      ) + ')';
  }
    return `${item?.name} ${role}`;
  }

  getTooltips(names) {
    return names.slice(1).map(x => this.getTooltip(x)).join(', ');
  }

}
